<template>
  <div>
    <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center">
      <!-- Mask -->
      <span class="mask bg-gradient-warning opacity-8"></span>
      <!-- Header container -->
      <div class="container-fluid d-flex align-items-center">
        <div class="row">
          <div class="col-lg-7 col-md-10">
            <p class="text-white mt-3 mb-5">
              Aqui você pode conferir todas as inscrições de startups na
              chamada. Toda nova inscrição aparecerá automaticamente na listagem
              abaixo.
            </p>
          </div>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--8">
      <div class="row mb-6">
        <div class="col-12">
          <call-card v-if="call" :call="call" :count="count" />
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div v-if="empty">
            <div class="row">
              <div class="col-12 te text-center">
                <badge type="warning">
                  Nenhuma startup inscrita na chamada "<b>{{ call.name }}</b
                  >" até o momento
                </badge>
              </div>
            </div>
          </div>
          <div v-else class="">
            <div class="card-deck">
              <apex-inscricoes :startupCallId="$route.params.id" />
            </div>
            <div class="d-flex justify-content-center mb-5">
              <div v-if="page != 0" class="mx-3" @click="handlePage(-1)">
                <i class="fas fa-arrow-left"></i>
              </div>
              <div class="mx-3">{{ page }}</div>
              <div
                v-if="countSubscriptions"
                class="mx-3"
                @click="handlePage(+1)"
              >
                <i class="fas fa-arrow-right"></i>
              </div>
            </div>
            <div class="card-deck">
              <div
                class="col-lg-3 col-md-6 mb-5 d-flex align-items-stretch"
                v-for="subscription in subscriptions"
                :key="subscription.startup.user_id"
              >
                <div class="card text-center flex-grow-1">
                  <div class="card-profile-image">
                    <img
                      :src="subscription.startup.logo.url"
                      class="card-image my-4"
                      alt="..."
                    />
                  </div>
                  <div class="card-body mt-8 py-0">
                    <h2 class="card-title text-orange mb-1">
                      {{ subscription.startup.name }}
                    </h2>
                    <div>
                      <div class="h5 font-weight-300 mb-1">
                        <i class="ni ni-pin-3 mr-2"></i
                        >{{ subscription.startup.city || "..." }},
                        {{ subscription.startup.state || "..." }}
                      </div>
                      <div class="h5 mt-2">
                        <badge type="info" class="bg-white">
                          {{ subscription.startup.sector }}
                        </badge>
                      </div>
                      <p
                        v-if="subscription.is_visible"
                        class="text-sm text-muted mt-3"
                      >
                        <badge
                          type="success"
                          title="Atualmente a startup está visível para avaliação dos investidores"
                          ><i class="fas fa-eye mr-1"></i> Visível para
                          avaliação</badge
                        >
                      </p>
                      <p v-else class="text-sm text-muted mt-3">
                        <badge
                          type="danger"
                          title="Atualmente a startup está invisível para avaliação dos investidores"
                          ><i class="fas fa-eye-slash mr-1"></i> Invisível para
                          avaliação</badge
                        >
                      </p>
                    </div>
                  </div>
                  <div class="card-footer text-center">
                    <router-link
                      :to="
                        '/admin/chamadas/' +
                        $route.params.id +
                        '/inscricoes/' +
                        subscription.id
                      "
                      ><i
                        class="fas ml-2 fa-comment-dots"
                        :class="{ 'text-dark-green': subscription.note }"
                        :title="[
                          subscription.note
                            ? 'Considerações já realizadas'
                            : 'Adicionar considerações',
                        ]"
                      ></i
                    ></router-link>
                    <span
                      @click="
                        handleOpenModalConfirmation(
                          subscription.id,
                          subscription.startup.name
                        )
                      "
                    >
                      <i
                        class="fas fa-trash ml-3 text-red cursor-pointer"
                        title="Deletar inscrição"
                      ></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <hr class="mt-5 mb-1" />
      <div class="row">
        <div class="col text-right">
          <base-button
            type="link"
            :custom="true"
            @click="
              $router.push(`/admin/chamadas/${call.id}/inscricoes-tabela`)
            "
            >Visualizar como tabela</base-button
          >
        </div>
      </div>
    </div>
    <modal
      :show.sync="modals.modalConfirmation"
      gradient="dark"
      modal-classes="modal-danger modal-dialog-centered"
    >
      <h6 slot="header" class="modal-title" id="modal-title-notification">
        Atenção!
      </h6>
      <div class="vld-parent" ref="modal_confirmation_delete">
        <div class="py-3 text-center">
          <i class="fa fa-rocket fa-3x"></i>
          <h4 class="heading mt-4">
            Você realmente deseja excluir a inscrição da startup
            <span class="text-warning">{{ modals.startupName }}</span
            >?
          </h4>
          <p class="mt-3 mb-0">
            Todas as respostas da startup na chamada serão perdidas.
          </p>
        </div>
      </div>

      <template slot="footer">
        <base-button
          type="link"
          text-color="white"
          class="ml-auto"
          @click="handleCloseModalConfirmation"
        >
          Voltar
        </base-button>
        <base-button
          type="white text-danger"
          @click="handleSubmitRemoveSubscription"
        >
          Confirmar exclusão
        </base-button>
      </template>
    </modal>
  </div>
</template>
<script>
import api from "@/services/api";

import CallCard from "@/components/CallCard";
import ApexInscricoes from "./ApexInscricoes.vue";
export default {
  name: "chamadas_inscricoes",
  components: {
    CallCard,
    ApexInscricoes,
  },
  data() {
    return {
      call: "",
      subscriptions: [],
      page: 0,
      empty: false,
      count: {
        subscriptions: 0,
        investors: 0,
      },
      modals: {
        modalConfirmation: false,
        startupName: "",
        subscriptionId: null,
      },
    };
  },
  async mounted() {
    await this.loadPageFunction();
  },
  methods: {
    async loadPageFunction() {
      const loader = this.$loading.show({
        width: 200,
        height: 200,
      });
      try {
        this.page = this.$route.query.page || 0;
        const {
          data: { call, subscriptions, subscriptions_count, investors_count },
        } = await api.get(
          `/adm/startup-calls/${
            this.$route.params.id
          }?subscriptions=true&count=true&offset=${
            Number(this.page) * 50
          }&limit=50`
        );
        if (call.sectors)
          call.sectors = call.sectors.split(";").filter((s) => s);
        this.call = call;
        const defaultLogoPath = "/img/pages/default_logo.png";
        subscriptions.forEach((subscription) => {
          if (!subscription.startup.logo)
            subscription.startup.logo = { url: defaultLogoPath };
        });
        if (subscriptions.length) this.subscriptions = subscriptions;
        else this.empty = true;
        this.count.subscriptions = subscriptions_count;
        this.count.investors = investors_count;
        loader.hide();
      } catch (e) {
        this.$toasted.error("Ocorreu um erro ao recuperar as startups");
      }
    },
    handlePage(value) {
      if (this.page === 0 && value === -1) return;
      this.page = Number(this.page) + value;
      this.$router.push({
        query: { page: this.page },
      });
      this.loadPageFunction();
    },
    handleOpenEvaluation() {
      this.$router.push(`/admin/chamadas/${this.$route.params.id}/avaliacao`);
    },
    handleOpenModalConfirmation(subscriptionId, startupName) {
      this.modals.subscriptionId = subscriptionId;
      this.modals.startupName = startupName;
      this.modals.modalConfirmation = true;
    },
    handleCloseModalConfirmation() {
      this.modals.modalConfirmation = false;
      this.modals.subscriptionId = null;
      this.modals.startupName = "";
    },
    async handleSubmitRemoveSubscription() {
      const loader = this.$loading.show({
        container: this.$refs.modal_confirmation_delete,
        width: 160,
        height: 160,
        opacity: 0,
      });
      try {
        await api.delete(
          `/adm/startup-call-subscriptions/${this.modals.subscriptionId}`
        );
        this.$toasted.show("Inscrição removida com sucesso");
        this.$router.go();
      } catch (e) {
        this.error = "Ocorreu um erro ao remover a inscrição da startup";
        this.$toasted.error(this.error);
      } finally {
        loader.hide();
      }
    },
  },
  computed: {
    countSubscriptions() {
      return this.subscriptions.length === 50;
    },
  },
};
</script>
<style scoped>
.card-image {
  width: 130px;
  height: 130px;
  border-radius: 10%;
  margin: auto;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
